// store.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    playerInfo: {},
    detailData: null,
    musicPlaying: false,
  },
  mutations: {
    SET_MUSIC_PLAYING: (state, playing) => {
      state.musicPlaying = playing
    },
    SET_PLAYER_INFO: (state, payload) => {
      state.playerInfo = payload
    },
    SET_DETAIL_DATA: (state, payload) => {
      state.detailData = payload
    },
    CLEAR_DETAIL_DATA: (state) => {
      state.detailData = null
    },
  }
})
